'use client';

import { useQuery } from '@tanstack/react-query';
import useIsMainnet from '../useIsMainnet';
import { getRetryDelayFn } from '../../utils/query/retryDelay';

type BNSOL_API_RESPONSE = {
	data: {
		apy: string;
	};
};

export const useBNsolFetch = () => {
	const isMainnet = useIsMainnet();

	return useQuery({
		queryKey: ['bnsolApy'],
		queryFn: async (): Promise<BNSOL_API_RESPONSE> => {
			const response = await fetch('/api/interest-breakdown/bnsol');
			if (!response.ok) {
				throw new Error(`Failed to fetch BNSOL metrics: ${response.status}`);
			}
			return response.json();
		},
		enabled: isMainnet,
		staleTime: 10 * 60 * 1000, // 10 minutes
		retryDelay: getRetryDelayFn(2000),
		retry: 3,
	});
};
